export default __webpack_public_path__ + "static/media/20t.503e2452.jpg";